import React from 'react';
/**
 * Date 日期小工具
 * @Author gufuyan
 * @Date 2018-08-30
 */
class DateFn {
    //函数参数默认值
    constructor() {
        this.dayCon = {
            _0: "星期日",
            _1: "星期一",
            _2: "星期二",
            _3: "星期三",
            _4: "星期四",
            _5: "星期五",
            _6: "星期六",
        };

        //个位转十位
        this.formatTen = (num) =>parseInt(num) > 9 ? (num + "") : ("0" + parseInt(num));

        // 能被4整除，但不能被100整除的年份   和 能被400整除的年份  是  闰年  ；反之 平年
        //平年2月28天，闰年2月29天
        this.yearType = (year)=>(year % 4 == 0 && year % 100 != 0) || (year % 400 == 0) ? "闰年" : "平年";

        //获取某月份最后一天 方法一  month 1~12
        this.monthMaxDay = (year, month)=>new Date(year, month, 0).getDate();

        //获取某月份最后一天 方法二  month 1~12
        this.getMonthMaxDay = (year, month)=> {
            let isLeap = (year) => year % 100 == 0 ? (year % 400 == 0 ? 1 : 0) : (year % 4 == 0 ? 1 : 0),//平年 瑞年
                monthDays = [31, 28 + isLeap(year), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            return monthDays[month - 1];
        };

        //获取某月份最后一天 方法三  month 1~12
        // this.maxDay = (date)=>new Date(year, month, 0).getDate();
        // new Date(new Date().setDate(0))上个月最后一天
        // new Date(new Date().setDate(1)这个月一号


    }

    /**
     * 转换日期格式
     * @param date
     * @param type
     * @returns {*}
     */
    format = (date, type) => {
        let formatCon = [
            {format: "yyyy-MM-dd", resFormat: (year, month, day) => `${year}-${month}-${day}`},
            {format: "yyyy/MM/dd", resFormat: (year, month, day) => `${year}/${month}/${day}`},
            {format: "yyyy.MM.dd", resFormat: (year, month, day) => `${year}.${month}.${day}`},
            {
                format: "yyyy-MM-dd HH:mm:ss",
                resFormat: (year, month, day, hour, minute, second) =>`${year}-${month}-${day} ${hour}:${minute}:${second}`
            }
        ];
        let _type = type || "yyyy-MM-dd";
        let _date = date instanceof Date ? date : new Date();
        let year = _date.getFullYear(),
            month = this.formatTen(_date.getMonth() + 1),
            day = this.formatTen(_date.getDate()),
            hour = this.formatTen(_date.getHours()),
            minute = this.formatTen(_date.getMinutes()),
            second = this.formatTen(_date.getSeconds());
        for (let o of formatCon) {
            if (_type == o.format) {
                return o.resFormat(year, month, day, hour, minute, second)
            }
        }
    };
    /**
     * 根据日期获取当前一周日期
     * @param date
     * @param type
     * @returns {Array}
     */
    getWeek = (date, type = "cn") => {
        let _date = date instanceof Date ? date : new Date();
        let day = _date.getDay();//0,1,2,3,4,5,6
        // type cn:"中国标准日期 周一到周日"  en:"美国标准日期 周日到周六"
        day = type == "cn" ? day - 1 : type == "en" ? day : day;
        let dayTime = _date.getTime();
        let weekList = [];
        for (let i = 0; i <= 6; i++) {
            let d = new Date(dayTime - (day - i ) * 86400000);
            weekList.push({
                date: this.format(d, "yyyy-MM-dd"),
                week: this.dayCon[`_${d.getDay()}`]
            })
        }
        return weekList
    };
}

let _Date = new DateFn();

export {_Date}


//原生封装
// const _Date = function () {
//     //获取星期 ，getDay()的值有： 1一，2二，3三，4四，5五，6六，0日
//     this.dayCon = {
//         _0: "星期日",
//         _1: "星期一",
//         _2: "星期二",
//         _3: "星期三",
//         _4: "星期四",
//         _5: "星期五",
//         _6: "星期六",
//     };
//     this.formatTen = (num) =>num > 9 ? (num + "") : ("0" + num);
// };
//
// _Date.prototype.format = (date, type) => {
//     let __Date = new _Date();
//     let formatCon = [
//         {format: "yyyy-MM-dd", resFormat: (year, month, day) => `${year}-${month}-${day}`},
//         {format: "yyyy/MM/dd", resFormat: (year, month, day) => `${year}/${month}/${day}`},
//         {format: "yyyy.MM.dd", resFormat: (year, month, day) => `${year}.${month}.${day}`},
//         {
//             format: "yyyy-MM-dd HH:mm:ss",
//             resFormat: (year, month, day, hour, minute, second) =>`${year}-${month}-${day} ${hour}:${minute}:${second}`
//         }
//     ];
//     let _type = type || "yyyy-MM-dd";
//     let _date = date instanceof Date ? date : new Date();
//     let year = _date.getFullYear(),
//         month = __Date.formatTen(_date.getMonth() + 1),
//         day = __Date.formatTen(_date.getDate()),
//         hour = __Date.formatTen(_date.getHours()),
//         minute = __Date.formatTen(_date.getMinutes()),
//         second = __Date.formatTen(_date.getSeconds());
//     for (let o of formatCon) {
//         if (_type == o.format) {
//             return o.resFormat(year, month, day, hour, minute, second)
//         }
//     }
// };
//
// _Date.prototype.getWeek = (date, type) => {
//     let __Date = new _Date();
//     let _date = date instanceof Date ? date : new Date();
//     let day = _date.getDay();//1 2
//     let dayTime = _date.getTime();
//     let weekList = [];
//     for (let i = 0; i <= 6; i++) {
//         let d = new Date(dayTime - (day - i ) * 86400000);
//         weekList.push({
//             date: __Date.format(d, "yyyy-MM-dd"),
//             week: __Date.dayCon[`_${d.getDay()}`]
//         })
//     }
//     return weekList
// };
//
// let _Date = new _Date();

